import { Injectable } from '@angular/core';
import { Order } from '../models/order.model';

@Injectable({
  providedIn: 'root'
})
export class DescriptionService {
  // Order: Order = {} as Order;
  Order:any = undefined;
  statusRsea:any = undefined;
  Item:any=undefined;
  NumberOfNeight:any = undefined;
  typeRoom:any=undefined;
  roomIndex:any;
  MapRoom = new Map();
  typeRoomModel:any[] = [];
  AffectRoomModel:any[] = [];
  roomId:any[]=[];
  pathforreturn:any = undefined;
  CheckinDetails:any = undefined;
  createdDetails : any = undefined ;
  ReservationsStatusDetails:any = undefined;
  BokingNumberDetails:any =  undefined;
  numberAgenceFilter:any = undefined;
  GuestDetails:any = undefined;
  customerDetails:any = undefined;
  checkoutDetails:any = undefined;
  roomIDExist:any = undefined
  clientSelected:any = undefined;
  roomAffectation:boolean = false;
  changedprice:boolean =  false;
  clientInfo= {
    civilite: "",
    firstName: "",
    lastName: "",
    countryCode: "",
    phone: "",
    email: "",
    countryName:"",
    city: ""
  };
  cancellationTrue:boolean =  false;
  NumberDetails:any =  undefined;
  CustomerDetails:any =  undefined;
  ProductDetails:any =  undefined;
  SupplierDetails:any =  undefined;
  StatusDetails:any =  undefined;
  BudgetDetails:any =  undefined;
  resa:any = undefined;
  clientselected:any;
  Products:any = undefined;
  existSegment:boolean = false;
  editItemFrom:string = '';
  value:any = undefined;
  createdTo:any = undefined;
  createdFrom:any = undefined;
  constructor() { }


}
